module.exports = __webpack_public_path__ + "img/stock5.b9bb0799.png";